export enum LeaveRequestStatus {
Temporary,
Pending,
Validating,
Approved,
Rejected,
Cancelled,
}
